import {
    REQUEST_APPEARANCE_GET_ACTION,
    RECEIVE_APPEARANCE_GET_SUCCESS,
    RECEIVE_APPEARANCE_GET_FAILURE,
  } from '../actions/appearanceGetAction';

  export const initialState = {
    appearance: null,
    isFetching: false,
    error: null
  };

  export default ( reduxState = initialState, action ) => {
    const { type, payload } = action;

    switch(type) {
      case REQUEST_APPEARANCE_GET_ACTION:
        return {
          ...reduxState,
          appearance: null,
          isFetching: true,
          error: null,
        };
      case RECEIVE_APPEARANCE_GET_SUCCESS:
        return {
          ...reduxState,
          appearance: payload.appearance,
          isFetching: false,
          error: null,
        };
      case RECEIVE_APPEARANCE_GET_FAILURE:
        return {
          ...reduxState,
          isFetching: false,
          error: payload.error,
          appearance: null,
        };
      default:
        return reduxState;
    }
  };



// WEBPACK FOOTER //
// ./src/appearances/reducers/appearanceGetReducer.js